import { number } from 'yup';
import {smallTime} from '../Models/Utils/Utils'
import  StringUtils from '../Utils/StringUtils'

export default class TmeUtils
{
    static  isInteger(str:any) {
        if (typeof str != "string") return false 
        return !isNaN(parseInt(str));
      }

    static extratDateFromString(buffer:string)
    {
        //deve esere in formato yyyy-mm-ddtimezone oppure yyyy/mm/ddtimeone
        var date_part:string[];
        var y:number;
        var m:number;
        var d:number;

        date_part=buffer.split("-")
        if(date_part.length <=0) date_part=buffer.split("/");
        
        y = Number(date_part[0]);
        m =Number(date_part[1]);
        if(TmeUtils.isInteger(date_part[2]) )
             d = Number(parseInt( date_part[2]));
        else{
            let s = date_part[2];
            let out="";

            for(let idx=0;idx < s.length;idx++)
            {
                let token = s.slice(idx,idx+1);
                if(TmeUtils.isInteger(token))
                    out+=token;
                else
                 break;
            }
            d=Number(out);
        }
      return new Date(y,m-1,d);


    }

     static timeToParts(time:string,result:smallTime)
        {
        const idxDash=time.indexOf(":");

        result.hours=Number(time.substring(0, idxDash));
        result.minutes=Number(time.substring(idxDash+1, idxDash+3))
        result.seconds=0;
        }
    static dateDiffToTime(dateStart:Date,dateEnd:Date,time:smallTime)
    {
   
        var diff = (dateEnd.getTime() - dateStart.getTime())/60000;
        var diff_ore =  Math.floor(diff/60);
        var diff_minuti = diff % 60;
        time.hours = diff_ore;
        time.minutes = diff_minuti;
        time.seconds=0;
    }
    static timeToString(time:smallTime)
    {
        return StringUtils.pad(time.hours,2) + ":" + StringUtils.pad(time.minutes,2);
    }

}